/**
 * Site Ayarları ekranının, doğrulanmayı bekleyen bölümleri.
 *
 * Burada tutulmalarının sebebi: tasarım ve kod hazır ama arkasındaki mekanizma
 * teyit edilmediği için ekrana çıkarılmıyorlar. Doğrulandığında bayrağı `true`
 * yapmak yeterli — bölümü yeniden yazmak gerekmiyor.
 */

/**
 * Arama motorlarına dizine gönderim (Google Search Console / Bing / Yandex).
 *
 * KAPALI. Gerekçe (backend devir belgesi md.5): panelin kullanmayı planladığı
 * Google Indexing API, Google'ın resmî dokümanında yalnızca `JobPosting` ve
 * `BroadcastEvent` içerik türleri için destekleniyor. Normal otel sayfası o
 * yoldan dizine GİRMİYOR — yani "Dizine Gönder" butonu başarı mesajı verir,
 * sayfa dizine girmez. Gerçek mekanizma sitemap + Search Console.
 *
 * Açmadan önce: hangi API ile ne yapılacağı doğrulanmalı.
 */
export const SEARCH_ENGINE_SUBMISSION_ENABLED = false;

/**
 * Channex kanal yöneticisi bağlantısı.
 *
 * KAPALI. Gerekçe (backend devir belgesi md.4): status/connect uçları yok ve iş
 * "orta" değil, ayrı eksen — eşleme üç katman gerektiriyor, biri eksikse sonuç
 * sessizce sıfır çıkıyor. Uçlar yazılıp doğrulanana kadar "Bağla" açılmamalı.
 */
export const CHANNEX_CONNECT_ENABLED = false;
